'use client'
import Image from 'next/image';
import { iFacilitySimpelModel } from '@/app/models/apiModels/facilitySimpel';
import { GetAbsoluteUrlClient } from '@/app/helpers/clientUtilityHelper';
import { iImagePicker } from '@/app/models/blockTypes/imagePicker';
import styles from './facilitiesinarea.module.scss';

interface Props {
    model: iFacilitySimpelModel;
    showCity?: boolean;
    isInGrid?: boolean;
    defaultFacilityImage?: iImagePicker[];
    translations: any;
}

export default function Facility({ model, showCity, translations, defaultFacilityImage = undefined, isInGrid = false }: Props) {
    var defaultImage = defaultFacilityImage && defaultFacilityImage.length > 0 ? GetAbsoluteUrlClient(defaultFacilityImage[0].url) : "";

    return (
        <a href={model.path} key={model.id} className={`no-underline hover:underline rounded-3xl overflow-hidden ${isInGrid ? "h-full" : ""}`}>
            <div className={`flex w-full ${isInGrid ? "h-full" : ""}`}>
                <div className="relative overflow-hidden half-width">
                    <Image
                        src={GetAbsoluteUrlClient(model.imageUrl) || defaultImage}
                        fill
                        alt={model.name}
                        className="object-cover object-center"
                        sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw" // Add sizes prop
                    />
                    {(model.hasColdUnits || model.hasHeatedUnits) && (
                        <div className="absolute bottom-4 left-4 flex flex-col sm:flex-row gap-2">
                            {model.hasHeatedUnits && (
                                <div>
                                    <div className="chip text-white bg-gs-turquoise !rounded-3xl text-xs !px-4 gs-shadow ">
                                        {translations.general.heatedUnits}
                                    </div>
                                </div>
                            )}
                            {model.hasColdUnits && (
                                <div>
                                    <div className="chip text-white bg-gs-dark-grey !rounded-3xl text-xs !px-4 gs-shadow ">
                                        {translations.general.coldUnits}
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                    <div className="absolute left-4 top-[15px] bg-gs-white rounded-3xl pt-1 p-2">
                        {model.hasGroundFloorUnits ? (
                            <img src="/assets/img/icons/wheelchair-solid.svg" title={translations.pages.order.unitInformation.isHandicapAccessible} alt={translations.pages.order.unitInformation.isHandicapAccessible} className=" inline-block w-[20px] h-[20px]" />
                        ) : (
                            <img src="/assets/img/icons/icon-wheelchair-not.svg" title={translations.pages.order.unitInformation.isNotHandicapAccessible} alt={translations.pages.order.unitInformation.isNotHandicapAccessible} className="inline-block w-[20px] h-[20px]" />
                        )}
                    </div>
                </div>
                <div className="p-4 text-left half-width space-y-2 relative">
                    <h3 className="text-lg mb-0-i font-bold flex flex-nowrap justify-between items-center">
                        <span>{model.name}</span>
                        {model.showPreviousOrganization && model.previousOrganizationImageUrl.length > 0 && (
                            <img
                                src={model.previousOrganizationImageUrl}
                                className={`h-full w-auto max-h-[28px] ml-2`}
                                alt={model.previousOrganizationTitle}
                                title={model.previousOrganizationTitle}
                            />
                        )}
                    </h3>
                    <div className="text-sm mb-6-i">{model.streetAddress}
                        {showCity && (
                            <span>, {model.city}</span>
                        )}
                    </div>
                    {model.lowestPrice && model.lowestPrice > 0 && (
                        <div className="bg-gs-orange p-1 rounded-xl text-center text-sm font-color-white font-bold">{`${translations.blocks.storageSizesBlock.priceFrom} ${model.lowestPrice} ${translations.general.priceUnit}/${translations.general.shortMonth}`}</div>
                    )}
                </div>
            </div>
        </a>
    );
}